import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
const collapsibleTriggerVariants = cva(
  "flex w-full py-3 content-center cursor-pointer",
  {
    variants: {
      root: {
        default: "pl-6 pr-3",
        root: "px-3 border-b"
      },
      disabled: {
        default: "",
        disabled: ""
      }
    },
    compoundVariants: [
      {
        root: "root",
        disabled: "default",
        class: "bg-(--bg-2)"
      },
      {
        root: "root",
        disabled: "disabled",
        class: "bg-(--gray-tag-1)"
      }
    ],
    defaultVariants: {
      root: "default"
    }
  }
);
export {
  collapsibleTriggerVariants
};
//# sourceMappingURL=variants.js.map
